<template>
  <div class="carts-icon" @click="goCarts">
    <i></i>
    <div class="fix-num" v-if="cartNum > 0">
      <div class="cart-num">{{ cartNum }}</div>
      <div class="triangle-right"></div>
    </div>
  </div>
</template>

<script>
import { getCartNum } from './apis.js'

export default {
  data () {
    return {
      cartNum: 0
    }
  },

  created () {
    getCartNum()
    .then(({ data }) => {
      this.cartNum = data || 0
    })
  },

  methods: {
    goCarts () {
      window.location.href = '/cart'
    }
  }
}
</script>

<style lang="stylus">
 @import '../../common/styl/global'
.carts-icon
  position absolute
  z-index 9
  top rem(16)
  right rem(16)
  i
    display block
    width rem(18)
    height rem(18)
    background url(https://img.thebeastshop.com/app/4.0/icon/icon-cart-sm.png) 0 0 no-repeat
    background-size contain
  .fix-num
    position absolute
    top rem(-5)
    right rem(-10)
    .cart-num
      min-width rem(12)
      min-height rem(16)
      background #000
      display inline-block
      border-radius rem(8)
      font-size rem(10)
      line-height rem(16)
      color #fff
      text-align center
      padding 0 rem(2)
    // .triangle-right
    //   display inline-block
    //   width 0
    //   height 0
    //   border-top rem(5) solid transparent
    //   border-left rem(8) solid #000
    //   border-bottom rem(5) solid transparent
    //   position relative
    //   left rem(-8)
    //   top rem(2)
</style>




// WEBPACK FOOTER //
// index.vue?0492843c